import React from 'react'
import { useNavigate } from 'react-router-dom'

const OrgHandbookListPage: React.FC = () => {
    const navigate = useNavigate()

    return (
        <div className="flex flex-col h-full text-[#181818] dark:text-[#FFFFFF] ">
            <div className="bg-[#e5e5e5] dark:bg-[#111111]">
                <div className="w-auto h-20 mx-6 flex flex-row gap-x-5 ">
                    <div className="w-60 h-20 my-auto content-center ">
                        <p className="text-sm text-[#181818] dark:text-[#FFFFFF]">
                            Реестр справочников
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex flex-1 justify-center max-h-[calc(100vh_-_80px)] p-5 bg-[#f0f3f5] dark:bg-[#181818]">
                <div className="flex flex-col h-full w-[1260px] space-y-10">
                    {/* // body */}
                    <div className="flex bg-[#f0f3f5] dark:bg-[#181818] h-[calc(100vh_-_120px)]">
                        {/* table */}
                        <div className="flex flex-col h-full w-full">
                            {/* toolbar */}
                            <div className="flex flex-row gap-1 p-2 rounded-t-lg items-center text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#262427]">
                                <div className="w-6 h-6"></div>
                            </div>

                            {/* name */}
                            <div className="flex flex-row gap-1 h-10 text-[10px] px-2 bg-[#dbdbdb] dark:bg-[#2A282B] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                <div className="flex w-10 justify-center items-center text-center">
                                    №
                                </div>
                                <div className="flex flex-1 justify-center items-center text-center">
                                    Наименование справочника
                                </div>
                            </div>

                            {/* data */}
                            <div className="flex flex-col gap-1 py-1 h-dvh overflow-y-auto custom-scrollbar bg-[#e4e6e8] dark:bg-[#1D1C1E]">
                                {/* Вывод пользователей */}
                                <>
                                    <div
                                        className="flex flex-row gap-1 mx-1 px-1 text-[11px] rounded bg-[#f6f6f6] dark:bg-[#2A282B] hover:bg-[#FFFFFF] dark:hover:bg-[#373538] text-[#181818] dark:text-[#FFFFFF] cursor-pointer"
                                        onClick={() =>
                                            navigate('/hub/org/handbook/okpd2')
                                        }
                                    >
                                        <div className="flex w-10 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            1
                                        </div>
                                        <div className="flex flex-1 items-center justify-left px-2 py-2">
                                            ОКПД 2 - Общероссийский
                                            классификатор продукции по видам
                                            экономической деятельности
                                        </div>
                                    </div>

                                    <div
                                        className="flex flex-row gap-1 mx-1 px-1 text-[11px] rounded bg-[#f6f6f6] dark:bg-[#2A282B] hover:bg-[#FFFFFF] dark:hover:bg-[#373538] text-[#181818] dark:text-[#FFFFFF] cursor-pointer"
                                        onClick={() =>
                                            navigate('/hub/org/handbook/okved2')
                                        }
                                    >
                                        <div className="flex w-10 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            2
                                        </div>
                                        <div className="flex flex-1 items-center justify-left px-2 py-2">
                                            ОКВЭД 2 - Общероссийский
                                            классификатор видов экономической
                                            деятельности
                                        </div>
                                    </div>
                                </>
                            </div>

                            {/* buttons */}
                            <div className="flex flex-row gap-1 p-2 rounded-b-lg h-10 space-x-2 text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#262427]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrgHandbookListPage
